import React, { Component } from 'react';
import Card from '@bit/xseed.ui-components.card';
import { Title, Body, Text } from '../Common/Form';
import { quoters } from '../../ecosystem.config';
import QuotersListWrapper from './QuotersList.style';

import iconAuto from '../../assets/icons/icon-car.svg';
import iconYate from '../../assets/icons/icon-embarcadiones-placer.svg';
import iconHogar from '../../assets/icons/icon-house.svg';
import iconPyme from '../../assets/icons/pymes.png';
import iconGtia from '../../assets/icons/icon-handkey.svg';
import iconAP from '../../assets/icons/accesibilidad.png';
import iconSalud from '../../assets/icons/icon-salud.svg';
import iconDefault from '../../assets/icons/icon-image.svg';


class QuotersList extends Component {

  getIcon(quoter) {
    switch (quoter) {
      case quoters.AUTOSSOA.key:       return iconAuto;
      case quoters.AUTOSSTANDARD.key:  return iconAuto;
      case quoters.AUTOSECONOMICO.key: return iconAuto;
      case quoters.YATES.key:          return iconYate;
      case quoters.PYME.key:           return iconPyme;
      case quoters.PYMEFARMACIA.key:   return iconPyme;
      case quoters.GTIAALQUILER.key:   return iconGtia;
      case quoters.HOGAR.key:          return iconHogar;
      case quoters.APERSONALES.key:    return iconAP;
      case quoters.SALUD.key:          return iconSalud;
    }
    return iconDefault;
  }

  render() {
    const url = window.location.href;
    return (
      <Card className="Card--medium">
        <QuotersListWrapper>
          <Text style={{paddingTop: '25px'}} className="Text-question">Opciones de cotización</Text>
          <div className="QuotersList-container">
            { Object.keys(quoters).map((key, index) => {
              if (!quoters[key].enabled) return <></>;
              return (
                <a key={index} href={url + '/' + quoters[key].key} className="QuotersList-item">
                  <Card className="Card--small Card--fluid">
                    <div className="QuotersList-link">
                      <div className="QuotersList-link-content">
                        <img className="QuotersList-link-img" src={this.getIcon(quoters[key].key)} alt="" />
                      </div>
                      <div className="QuotersList-link-content"> {quoters[key].title} </div>
                    </div>
                  </Card>
                </a>
              )})
            }
          </div>
        </QuotersListWrapper>
      </Card>
    );
  }
}

export default QuotersList;
